/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { FullAssignment, Pagination, Setter } from "../../utils/Interfaces";
import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { getHandler, stdErrHandlerFactory } from "../../utils/Requests";

export function updateTechnicianAssignments(
    dispatch: Dispatch<AnyAction>,
    setAssignments: Setter<FullAssignment[]>,
    setLoading: Setter<boolean> = (setLoading) => {}
) {
    getHandler<Pagination<FullAssignment[]>>(
        "/api/tech-entries/get-my-entries",
        dispatch,
        (response) => setAssignments(response.data.results),
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}
